import { render } from "./IntroSection.vue?vue&type=template&id=94b74f7c&scoped=true"
import script from "./IntroSection.vue?vue&type=script&lang=js"
export * from "./IntroSection.vue?vue&type=script&lang=js"

import "./IntroSection.vue?vue&type=style&index=0&id=94b74f7c&scoped=true&lang=css"

import exportComponent from "/home/brandon/Code/Clients/PhilipComan/specialty-studio-vuetify-theme-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b74f7c"]])

export default __exports__